import React from 'react'
import Layout from '../Layout'
import PostAuctio from '../../../utils/CommonFunctionality/PostAuction'
import SEO from '../../../utils/CommonFunctionality/SEO'
const PostAuction = (props) => {
    return (
        <>
            <Layout props={props}>
                <SEO title={`${global?.storeDetails?.name} | Post an auction`} />
                <div className="postProductContainer">
                    <PostAuctio
                        defaultCountryCode={38}
                        addressSection={1}
                        extraSection={1}
                        LiquidationPalletFields={1}
                        theme="LiquidationPallet"
                        taxFree={1}
                        bottomErrorField={1}
                    />
                </div>
            </Layout>
        </>
    )
}

export default PostAuction
